import useControllersMiddleware from './useControllersMiddleware'

export default useControllersMiddleware
